<style lang="scss" src='./AlertChart.scss' scoped></style>
<template src="./AlertChart.html"></template>

<script>
import ApexChart from 'vue-apexcharts';
import {
    getSensorGraph,
    getSensor,
    getStationGraph
  } from '@/api/index';

let CounterForUpdates = 0;

export default {
  name: 'AlertChart',
  props: {
    sensor: {
      required: false,
    },
    station:{
      required: false,
    },
    alert: {
      requiered: false,
    },
  },
  
  components: {
      ApexChart,
  },

  data() {
    return ({
      loading: true,
      filters: {
        daysBack: null,
        alertType: null,
      },
      series: [{
          data: []
      }],
      options: [
          { text: this.$t('timePeriods.1D'), label: this.$t('timePeriods.last24H'), value: 1, resampleFreq: null},
          { text: this.$t('timePeriods.2D'), label: this.$t('timePeriods.last2D'), value: 2, resampleFreq: null},
          { text: this.$t('timePeriods.1W'), label: this.$t('timePeriods.lastWeek'), value: 7, resampleFreq: null},
          { text: this.$t('timePeriods.1M'), label: this.$t('timePeriods.lastMonth'), value: 30, resampleFreq: null},
          { text: this.$t('timePeriods.1Y'), label: this.$t('timePeriods.lastYear'), value: 365, resampleFreq: '8h'},
        ],
      charOpt: {
          xaxis: {
            type: 'datetime',
          },
        },
    });
  },
  computed: {
    noDataMessage() {
        return `${this.$t('timePeriods.noDataToShow')} ${this.filters.daysBack.label.toLowerCase()}`;
      },
  },
  watch: {
    alert: function (newAlert, oldAlert) {
      if (newAlert && oldAlert && newAlert.alert_id !== oldAlert.alert_id) {
        this.loadData();
      }
    },
  },

  methods: {

    filterByDays(daysBack){
      this.filters.daysBack = daysBack;
      this.getGraph();
    },

    async getGraph() {
        this.loading = true;
        let tempChartOptions = this.getChartOptions();
        let alertType = this.filters.alertType;

        this.unitOfMeasurament = this.G_getUOM({
          uom: alertType ? alertType.uom : this.alert.alert_type.uom
        });
        tempChartOptions.title.text = '.';
        tempChartOptions.yaxis.title.text = this.unitOfMeasurament;

        const data = {
          sensorId: this.sensor && this.sensor.sensor_id,
          alias: alertType.alias,
          until: this.filters.daysBack.value,
          resampleFreq: this.filters.daysBack.resampleFreq,
          device_sn: this.station && this.station.device_sn
        };

        let tempMin = null;
        let tempMax = null;
        let apiCall = null;

        if(this.alert){
          apiCall = this.alert.station_id ? getStationGraph : getSensorGraph;
        }else{
          apiCall = getSensorGraph;
        }

        await apiCall(data).then((res) => {
          let tempSeries = [];
          if (res.length > 0) {

            tempSeries = res.map((item) => {
              let reading = this.G_getMeasurement({
                  val: item[data.alias],
                  uom: alertType.uom,
                  addUnit: false,
                  invertUOM: false
                });
              
              if (tempMin == null) {
                tempMin = Number(reading);
              } else {
                if (Number(reading) < tempMin) {
                  tempMin = Number(reading);
                }
              }
              if (tempMax == null) {
                tempMax = Number(reading);
              } else {
                if (Number(reading) > Number(tempMax)) {
                  tempMax = Number(reading);
                }
              }
              return [
                new Date(item.reading_time).getTime(),
                reading
              ]
            });
          }
          this.series = [{
            name: this.$t(alertType.i18n),
            data: tempSeries
          }];
        });
        let min = 0;
        let max = 0;
        
        /*Ommit annotations
        if (this.alert && this.alert.station_id) {
          if(this.alert.alert_type_id != "WS_COMMUNICATION_FAILURE"){
            const threshold = this.alert.station.thresholds.find(t => t.alert_type_id === this.alert.alert_type_id);
            const maxTh = threshold.max ? this.G_getMeasurement({ val: threshold.max, uom: threshold.alert_type.uom }): null;
            const maxVal = threshold.alert_type.max ? this.G_getMeasurement({ val: threshold.alert_type.max, uom: threshold.alert_type.uom }): null;
            const minTh = threshold.min ? this.G_getMeasurement({ val: threshold.min, uom: threshold.alert_type.uom }): null;
            const minVal = threshold.alert_type.min ? this.G_getMeasurement({ val: threshold.alert_type.min, uom: threshold.alert_type.uom }): null;

            min = minTh;
            max = maxTh;
            tempMin= Number(minVal) < Number(tempMin) ? Number(minVal) : tempMin;
            tempMax= Number(maxVal) > Number(tempMax) ? Number(maxVal) : tempMax;
            
            if(min){
              tempChartOptions.annotations.yaxis[0].y = min;
              tempChartOptions.annotations.yaxis[0].label.text = 'Min ' + min + this.unitOfMeasurament
              tempChartOptions.annotations.yaxis[1].y = max;
              tempChartOptions.annotations.yaxis[1].label.text = 'Max ' + max + this.unitOfMeasurament;
            }else{
              tempChartOptions.annotations.yaxis[0].y = max;
              tempChartOptions.annotations.yaxis[0].label.text = 'Max ' + max + this.unitOfMeasurament;
              tempChartOptions.annotations.yaxis[1] = null;
            }
          }
        
        } else if (this.sensor.threshold && alertType.uom !== this.consts.UOM.RSSI) {
          min =
            this.G_getMeasurement({
              val: this.sensor.threshold[`min_${alertType.key}`],
              uom: alertType.uom,
              addUnit: false,
              invertUOM: false
            });
          max =
            this.G_getMeasurement({
              val: this.sensor.threshold[`max_${alertType.key}`],
              uom: alertType.uom,
              addUnit: false,
              invertUOM: false
            });

          if(this.alert.is_night_time && this.alert.alert_type_id == 'GROUND_TEMPERATURE'){
            min =
              this.G_getMeasurement({
                val: this.sensor.threshold[`min_night_temp`],
                uom: alertType.uom,
                addUnit: false,
                invertUOM: false
              });
            max =
              this.G_getMeasurement({
                val: this.sensor.threshold[`max_night_temp`],
                uom: alertType.uom,
                addUnit: false,
                invertUOM: false
              });
          }
          tempChartOptions.annotations.yaxis[0].y = min;
          tempChartOptions.annotations.yaxis[0].label.text = 'Min ' + min + this.unitOfMeasurament
          tempChartOptions.annotations.yaxis[1].y = max;
          tempChartOptions.annotations.yaxis[1].label.text = 'Max ' + max + this.unitOfMeasurament;
        } else {
          tempChartOptions.annotations.yaxis = [];
          tempChartOptions.annotations.yaxis[0].label.text = 'Min ' + min + this.unitOfMeasurament
        }
        */
        tempChartOptions.annotations.yaxis = [];
        //let yaxisMin = (min < tempMin) ? min : tempMin;
        //tempChartOptions.yaxis.min = (yaxisMin > 0) ? 0 : yaxisMin;
        tempChartOptions.yaxis.min = Number(tempMin);
        //if (tempMax > max) {
        //  tempChartOptions.yaxis.max = tempMax;
        //} else {
        //  tempChartOptions.yaxis.max = max;
        //}
        tempChartOptions.yaxis.max = Number(tempMin) == Number(tempMax) ? Number(tempMax) + 0.05 : Number(tempMax);
        this.charOpt = tempChartOptions;
        this.loading = false;
    },

    getChartOptions() {
        return {
          chart: {
            type: 'area',
            animations: {
              enabled: false,
            },

            stacked: false,
            height: 350,
            zoom: {
              type: 'x',
              enabled: true,
              autoScaleYaxis: true
            },
            toolbar: {
              show: false,
            },
            events: {
              updated: function (chartContext, config) {
                if (CounterForUpdates != 0) {
                  var elmnt = document.getElementById("chart");
                  if (elmnt) {
                    elmnt.scrollIntoView();
                  }
                }
                ++CounterForUpdates;
              }
            }
          },
          dataLabels: {
            enabled: false
          },
          // markers: {
          //   size: 0,
          //   colors: '#018ffb',
          //   strokeColors: '#018ffb',
          //   strokeWidth: 0,
          // },
          title: {
            text: 'title',
            align: 'left'
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              inverseColors: false,
              opacityFrom: 0.4,
              opacityTo: 0,
              stops: [0, 90, 100]
            },
          },
          stroke: {
            width: [3]
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                return val ? (val).toFixed(2) : 0;
              },
            },
            title: {
              text: 'unitOfMeasurament'
            },
            min: -5,
            max: 150,
          },
          xaxis: {
            type: 'datetime',
            labels: {
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'h:mm TT',
              },
            }
          },
          tooltip: {
            x: {
              show: true,
              formatter: (val) => {
                return this.G_formatDate({date: val, pretty: false});
              }
            },
            shared: false,
            y: {
              formatter: (val) => {
                return val ? `${(val).toFixed(2)}${this.unitOfMeasurament}` : '';
              }
            }
          },
          annotations: {
            yaxis: [{
              y: 10,
              borderColor: 'red',
              label: {
                borderColor: 'red',
                style: {
                  color: '#fff',
                  background: 'red',
                },
                text: 'Min',
              }
            }, {
              y: 60,
              borderColor: 'red',
              label: {
                borderColor: 'red',
                style: {
                  color: '#fff',
                  background: 'red',
                },
                text: 'Max',
              }
            }, ],
          }
        }
      },

    loadData() {
      if (this.alert) {
        let alertType = this.consts.AlertType[this.alert.alert_type_id];
        this.filters.alertType = alertType;
        this.getGraph();
      }
    },
    
  },

  beforeCreate() {},

  created() {},

  mounted() {
    CounterForUpdates = 0;
    this.filters.daysBack = this.options[0];

    this.loadData();
  },
};
</script>
